import {useParams} from 'react-router';

import {skipToken} from '@reduxjs/toolkit/query';

import {and} from '@edna/utils';

import {useGetSupportClientQuery} from 'src/containers/SupportClients/api';
import {EPermission, EResellerIds, useGetTenantDataQuery, usePermission} from 'src/containers/User';

const useStripeOnetimePaymentEnabled = () => {
  const hasPermission = usePermission(EPermission.PERMISSION_STRIPE_ONETIME_INVOICE);

  return hasPermission;
};

const usePayKeeperOnetimePaymentEnabled = () => {
  const {id: tenantId} = useParams<'id'>();

  const hasViewPermission = usePermission(
    and<EPermission>('PERMISSION_VIEW_PAYKEEPER', 'PERMISSION_VIEW_BILLING'),
  );

  const {data: tenantData} = useGetTenantDataQuery(undefined, {skip: !!tenantId});
  const {data: supportClient} = useGetSupportClientQuery(tenantId ?? skipToken);

  const resellerId = tenantId ? supportClient?.resellerId : tenantData?.resellerId;
  const isSupport = !!tenantId;

  return (isSupport || hasViewPermission) && resellerId === EResellerIds.OSK_ID;
};

export {useStripeOnetimePaymentEnabled, usePayKeeperOnetimePaymentEnabled};
